module.exports = __webpack_public_path__ + "img/module-64-bg.9aae30c0.webp";